// import { useSetting } from "@faire/marketplace-lib/settings/__internal__/useSetting";
import { getSettingValueWithoutAssignment } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/getSetting";
import { FE_ENABLE_UX_CAM_SESSION_RECORDING_250326 } from "@faire/retailer-settings/FE_ENABLE_UX_CAM_SESSION_RECORDING_250326";

/**
 * Returns whether UXCam session recording is enabled
 * @returns true if UXCam session recording is enabled, false otherwise
 */
export const getSettingRecordSessionUXCam = (): boolean =>
  getSettingValueWithoutAssignment(FE_ENABLE_UX_CAM_SESSION_RECORDING_250326);
